"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isForeignerByUinfin = exports.getUinfinChecksum = exports.checkUinfinPattern = exports.validateUinfin = exports.UinfinType = void 0;
// Need to include /common/regex, otherwise the tests fail with
// TypeError: (0 , utils_1.IsString) is not a function. No idea why.
const regex_1 = require("../../birth-registration-v2/common/regex");
const EnumUtils_1 = require("../native/EnumUtils");
var UinfinType;
(function (UinfinType) {
    UinfinType["LOCAL_S_PREFIX"] = "S";
    UinfinType["LOCAL_T_PREFIX"] = "T";
    UinfinType["FOREIGN_F_PREFIX"] = "F";
    UinfinType["FOREIGN_G_PREFIX"] = "G";
    UinfinType["FOREIGN_M_PREFIX"] = "M";
})(UinfinType || (exports.UinfinType = UinfinType = {}));
(function (UinfinType) {
    UinfinType.fn = {
        values: EnumUtils_1.EnumUtils.valuesFunc(UinfinType),
        toEnumKey: EnumUtils_1.EnumUtils.toEnumKeyFunc(UinfinType),
        toEnumValue: EnumUtils_1.EnumUtils.toEnumValueFunc(UinfinType),
    };
})(UinfinType || (exports.UinfinType = UinfinType = {}));
const DIGIT_WEIGHTS = [2, 7, 6, 5, 4, 3, 2];
const LOCAL_SUFFIX_CHAR_MAP = ["J", "Z", "I", "H", "G", "F", "E", "D", "C", "B", "A"];
const FOREIGN_SUFFIX_CHAR_MAP = ["X", "W", "U", "T", "R", "Q", "P", "N", "M", "L", "K"];
const FOREIGN_M_SUFFIX_CHAR_MAP = ["X", "W", "U", "T", "R", "Q", "P", "N", "J", "L", "K"];
function validateUinfin(uinfin) {
    const isString = typeof uinfin === "string";
    if (isString) {
        const isValidUinfinPattern = checkUinfinPattern(uinfin);
        const isValidCheckSum = uinfin.charAt(8) === getUinfinChecksum(uinfin);
        return isValidUinfinPattern && isValidCheckSum;
    }
    return false;
}
exports.validateUinfin = validateUinfin;
function checkUinfinPattern(uinfin) {
    return regex_1.Regex.UINFIN.test(uinfin);
}
exports.checkUinfinPattern = checkUinfinPattern;
function getUinfinChecksum(uinfin) {
    let totalWeights = 0;
    for (let i = 0; i < 7; ++i) {
        totalWeights += Number(uinfin.charAt(i + 1)) * DIGIT_WEIGHTS[i];
    }
    const type = uinfin.charAt(0);
    if (type === UinfinType.LOCAL_T_PREFIX || type === UinfinType.FOREIGN_G_PREFIX) {
        totalWeights += 4;
    }
    if (type === UinfinType.FOREIGN_M_PREFIX) {
        totalWeights += 3;
    }
    let checkSum;
    if (type === UinfinType.LOCAL_S_PREFIX || type === UinfinType.LOCAL_T_PREFIX)
        checkSum = LOCAL_SUFFIX_CHAR_MAP[totalWeights % 11];
    else if (type === UinfinType.FOREIGN_M_PREFIX) {
        checkSum = FOREIGN_M_SUFFIX_CHAR_MAP[totalWeights % 11];
    }
    else {
        checkSum = FOREIGN_SUFFIX_CHAR_MAP[totalWeights % 11];
    }
    return checkSum;
}
exports.getUinfinChecksum = getUinfinChecksum;
function isForeignerByUinfin(uinfin) {
    const type = uinfin.charAt(0);
    return (validateUinfin(uinfin) &&
        (type === UinfinType.FOREIGN_F_PREFIX ||
            type === UinfinType.FOREIGN_G_PREFIX ||
            type === UinfinType.FOREIGN_M_PREFIX));
}
exports.isForeignerByUinfin = isForeignerByUinfin;
//# sourceMappingURL=sg-uinfin.js.map